import React, {Suspense} from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import Paper from '@mui/material/Paper';
import { theme } from './components/muiTheme';
import { useFullPage } from './contexts/FullPageContext';
import { useAuthStore } from './contexts/AuthContext';
import { useAccountStore } from './contexts/AccountContext';
import LoadingContent from './components/progress/LoadingContent';

const Workspace = React.lazy(() => import('./pages/workspace/Workspace'));
const Marketplace = React.lazy(() => import('./pages/marketplace/Marketplace'));
const Settings = React.lazy(() => import('./pages/settings/Settings'));
const DataBuilder = React.lazy(() => import('./pages/data-builder/DataBuilder'));
const UserManagement = React.lazy(() => import('./pages/usermanagement/UserManagement'));

function MainRoutes() {
    const { isFullPage } = useFullPage();
    const { accounts } = useAccountStore();
    const { user, selectedAccount } = useAuthStore();
    const [canNavToMarket, setCanNavToMarket] = useState(true);

    //if the login user is superAdmin, we can navigate from marketplace
    //otherwise check if the selectedAccount has settings view-marketplace, if yes, we can navigate, if not, can't navigate
    useEffect(() => {
        if (user.isSuperAdmin) {
            setCanNavToMarket(true);
        } else {
            if (Object.keys(accounts).length === 0) return;
            const settingsInAccount = accounts[selectedAccount.id]["AccountSettings"].map((accountsetting) => accountsetting.Setting.slug);
            if (settingsInAccount.includes("view-marketplace")) {
                setCanNavToMarket(true);
            } else {
                setCanNavToMarket(false);
            }
        }
    }, [accounts, user, selectedAccount]);

    return (
        <Paper sx={{
            height: "96%",
            borderRadius: isFullPage ? "0px" : "10px",
            backgroundColor: theme.palette.white.secondary,
            padding: theme.page.itemSpacing,
            width: "100%",
            className: "white-bubble-container"
        }} elevation={0}>
            <Suspense fallback={<LoadingContent />}>
                <Routes>
                    {user.viewContentStartOn ?
                        <>
                            <Route path= '/workspace/*' element= {<Workspace /> } />
                            {canNavToMarket && <Route path= '/marketplace/*' element= {<Marketplace />} />}
                            <Route path= '/user-management/*' element= {<UserManagement /> } />
                            {/* <Route path= '/settings' element= {<Settings />} /> */}
                            <Route path= '/data-builder' element= { process.env.REACT_APP_INNO_ENV !== "production" && user.isSuperAdmin ? <DataBuilder /> : <Workspace />} />
                            <Route path= '*' element={<Navigate to='/workspace' />} /> 
                        </> :
                        user.isSuperAdmin ? 
                        <>
                            <Route path= '/workspace/*' element= { <Workspace /> } />
                            <Route path= '*' element={<Navigate to='/workspace' />} />
                        </> :
                        <>
                            <Route path= '/marketplace/*' element= {<Marketplace />} />
                            <Route path= '*' element={<Navigate to='/marketplace' />} />
                        </>
                    }
                </Routes>
            </Suspense>
        </Paper>
    )
}

export default MainRoutes;